import React from "react";
import MainTable from "../../Components/Tables/Main/MainTable";
import { useUsers } from "../../Hooks/useUsers";
import { useCompanies } from "../../Hooks/useCompanies";
import AddBox from '@material-ui/icons/AddBox';

const Users = () => {
  const [usersData, addUser, updateUser, disableUser, enableUser] = useUsers();

  let [companies] = useCompanies();
  companies = companies.reduce(function (acc, cur) {
    const { id, name } = cur;
    acc[id] = name;
    return acc;
  }, {});

  const columns = [
    { title: "Id", field: "id", hidden: true },
    { title: "Nombre", field: "name", defaultSort: "asc" },
    {
      title: "Contraseña",
      field: "password",
      emptyValue: "************",
      editable: "onAdd",
    },
    { title: "Email", field: "email" },
    { title: "Empresa", field: "companyName", lookup: companies },
    {
      title: "Tipo",
      field: "type",
      lookup: { driver: "Conductor", manager: "Manager" },
    },
    {
      title: "Activo",
      field: "active",
      lookup: { true: "Sí", false: "No" },
      editable: "never",
    },
  ];

  const actions = [
    (rowData) => ({
      icon: AddBox,
      tooltip: "Activar",
      onClick: (event, rowData) => enableUser(rowData),
      disabled: rowData.active,
    }),
  ];

  const editRequiredFiles = ["name", "email", "type", "companyName" ];

  return (
    <MainTable
      {...{ editRequiredFiles }}
      title="Usuarios"
      columns={columns}
      actions={actions}
      data={usersData}
      requiredFields={[...editRequiredFiles, "password"]}
      deleteText="El usuario podrá ser reactivado luego"
      onRowAdd={addUser}
      onRowUpdate={updateUser}
      onRowDelete={disableUser}
      isDeletable={(row) => row.active}
    />
  );
};

export default Users;



// WEBPACK FOOTER //
// ./src/Containers/Users/Users.js